import flightConditionApplication from "./FlightConditionApplications/routes.js";

// Legacy open forms for Signatories and FlightTestCrew have been sunset (2026 external self-service plan).
// They are replaced by authenticated claim-based self-service at /FlightTestCrew/Self and /Matrices/SignatoryMatrix/Self
// (rendered in clean no-side-nav layout).
// The routes below are kept only for FlightConditionApplications (still used).
// Old paths will 404 or can be redirected at hosting level.
export default [
  {
    "path": "/___/Signatories",
    "components": {
        "open-forms": () => import("./Signatories/NewApplication.vue")
    },
    "name": "open-form-sig",
    "meta": {
        "open": true
    }
}, {
    "path": "/___/Signatories/:id",
    "components": {
        "open-forms": () => import("./Signatories/FormContainer.vue")
    },
    "name": "open-form-sig-id",
    "meta": {
        "open": true
    },
    "children": [{
        "path": "contact",
        "component": () => import("./Signatories/forms/Contact.vue"),
        "name": "contact"
    }, {
        "path": "address",
        "component": () => import("./Signatories/forms/Address.vue"),
        "name": "address"
    }, {
        "path": "role",
        "component": () => import("./Signatories/forms/Role.vue"),
        "name": "role"
    }, {
        "path": "questions",
        "component": () => import("./Signatories/forms/Questions.vue"),
        "name": "questions"
    }, {
        "path": "supportingDocuments",
        "component": () => import("./Signatories/forms/SupportingDocuments.vue"),
        "name": "supportingDocuments"
    }]
}, {
    "path": "/___/Signatories/end",
    "components": {
        "open-forms": () => import("./Signatories/End.vue")
    },
    "name": "open-form-sig-end",
    "meta": {
        "open": true
    }
},
  ...flightConditionApplication
];


